import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import { Button, Select, Grid , MenuItem, Tooltip } from '@mui/material'
import { DataGrid } from "@mui/x-data-grid"
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import EditableInput from "./editableInput"
import EditableNumberInput from "./editableNumberInput"
import EditableReceivableInput from "./editableReceivableInput"
import EditableNumberReceivableInput from "./editableNumberReceivableInput"
import dayjs from 'dayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import TextField from '@mui/material/TextField'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { onlyTextRegex } from "src/utils/strings"
import TextFieldFormatCurrency from "src/components/text-field-format-currency"

const FormWalletComponent = ({
    tableKey,
    nomeCarteira,
    setNomeCarteira,
    errorNomeCarteira,
    setErrorNomeCarteira,
    valorPercentil,
    setValorPercentil,
    valorCaixa,
    setValorCaixa,
    operationsState, 
    setOperationsState,
    subordinationsState,
    handleAddSubordination,
    borderErrorSubordinacoes,
    borderErrorOperacoes,
    handleOperationNumericChange, 
    handleOperationChange, 
    handleSubordinationNumericChange,
    handleSubordinationChange,
    handleRemoveSubordination,
    handleUploadForm, 
    closeModal,
    openAlert
}) => {


    // Memoriza borderErrorSubordinacoes para evitar re-renderizações desnecessárias
    const borderErrorSubordinacoesMemo = useMemo(() => ({...borderErrorSubordinacoes}), [borderErrorSubordinacoes])

    // Memoriza borderErrorOperacoes para evitar re-renderizações desnecessárias
    const borderErrorOperacoesMemo = useMemo(() => ({...borderErrorOperacoes}), [borderErrorOperacoes])


    const handleAddOperation = () => {
        setOperationsState((prevState) => { 
            if (prevState.length >= 15){
                openAlert("O máximo de operações permitidas é 15")
                return prevState
            }

            const lastId = prevState.length > 0 ? prevState[prevState.length - 1].id : 0
            const nextId = lastId + 1

            return [
                ...prevState,
                {
                    id: nextId,
                    idOperacao: '',
                    dataReferencia: null,
                    dataOriginacao: null,
                    dataVencimento: null,
                    CNPJ_CPF: '',
                    indexador: '',
                    volumeFinanceiro: '',
                    taxaOperacao:'',
                    prazoOperacao: '',
                    diasAtraso: '',
                    PDDObservada: '',
                    valorGarantia: '',
                    recebivel:'',
                    garantia:'',
                    PDInterno:'',
                    LGDInterno:'',
                    EADInterno:'',
                    ScoreInterno:''
                }
            ]
            
        })
    }

    const handleRemoveOperation = (id) => {
        console.log(id)

        if (operationsState.length < 2) return
        const list = operationsState.filter(item => item.id !== id)
        setOperationsState(list)
    }

    const indexadorOptions = [
        "TR", "TLP", "TJLP", "SELIC_Taxa", "SELIC_Percentual", "PRE", "IPC_FIPE", "IPCA", "INPC", "INCC_DI", "IGPM", "IGPDI", "DOLAR", "CDI_Taxa", "CDI_Percentual"
    ]

    const recebivelOptions = [
        "CONFISSAO DE DIVIDA PF", "CAPITAL DE GIRO PJ", "CARTAO DE CREDITO PARCELADO PF", "CARTAO DE CREDITO PARCELADO PJ", "CONSIGNADO INSS PF", "CONSIGNADO PRIVADO PF",
        "OUTROS RECEBIVEIS PJ", "CARTAO DE CREDITO ROTATIVO PF", "CARTAO DE CREDITO ROTATIVO PJ", "OUTROS RECEBIVEIS PF", "RECEBIVEIS DE CARTAO (FUMACA)",
        "FINANCIAMENTO ESTUDANTIL PF", "FINANCIAMENTO VEICULO PF", "CDC PF", "EMPRESTIMO COM GARANTIA PF", "CONSIGNADO PUBLICO PF", "FINANCIAMENTO IMOBILIARIO PF",
        "FINANCIAMENTO PJ", "DUPLICATA DE SERVICOS", "ANTECIPACAO DE RECEBIVEIS DE CARTAO", "DUPLICATA MERCANTIL", "FINANCIAMENTO AGRICOLA PF", "FINANCIAMENTO AGRICOLA PJ"

    ]

    const garantiaOptions = [
            "SEM GARANTIA", "OUTRAS GARANTIAS", "AF DE IMOVEIS", "AF DE OUTROS BENS IMOBILIARIOS", "AF DE BENS MOBILIARIOS", "HIPOTECA DE IMOVEIS",
            "PENHOR AGRICOLA", "AVAL", "FIANCA", "CARTA FIANCA", "CASH COLLATERAL", "TITULOS E VALORES MOBILIARIOS", "CESSAO FIDUCIARIA DE RECEBIVEIS PERFORMADOS",
            "CESSAO FIDUCIARIA DE RECEBIVEIS A PERFORMAR"
    ]

    const cleanFormattedNumber = (value) => {
        if (!value) return "0.00"
        return String(value).replace(/\./g, '').replace(',', '.')
    }
    
    return (
        <form onSubmit={(e) => {
            e.preventDefault()
            handleUploadForm()
        }}>
            <Grid container direction={'column'} rowSpacing={2}>
                <Grid item width={'100%'}>
                    <DataGrid
                        getRowId = {(row) => row.id} // Define a chave única da linha
                        autoHeight={false}
                        autoPageSize={false}
                        showColumnVerticalBorder
                        showCellVerticalBorder
                        hideFooter
                        rows={operationsState}
                        columns={[
                            {
                                field: 'id',
                                headerName: '#',
                                align: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                headerAlign: "center",
                            },
                            {
                                field: 'idOperacao',
                                headerName: 'IDOperacao',
                                description: 'Insira o nome da operação caso queira',
                                align: "center",
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    console.log("Valor de idOperacao:", value)
                                    console.log("idOperacao: ", value, "| Tipo: ", typeof value)
                                
                                    return (
                                        <EditableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('idOperacao', id, cellValue)}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'dataReferencia',
                                headerName: 'DataReferencia',
                                description: 'Preencha a data de referência de cada operação',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    // const index = id ? id - 1 : 0
                                    const index = operationsState.findIndex((op) => op.id === id)  
                                    console.log("Valor do index dataReferencia:", index)
                                    console.log("dataReferencia: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError dataReferencia:", borderErrorOperacoes.dataReferencia)       
                                                              
                                    const dataReferenciaError = borderErrorOperacoesMemo[`op_${index}`]?.dataReferencia ?? false
                                    console.log("Valor de dataReferenciaError:", dataReferenciaError)

                                    return (
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                format="DD/MM/YYYY"
                                                value={value ? dayjs(value, "DD/MM/YYYY") : null}
                                                onChange={(newValue) => {
                                                    const formattedDate = newValue ? dayjs(newValue).format('DD/MM/YYYY') : ""
                                                    handleOperationChange('dataReferencia', id, formattedDate)
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        error: dataReferenciaError,
                                                        helperText: dataReferenciaError ? 'Data inválida' : '',
                                                        variant: "outlined",
                                                        fullWidth: true
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    )
                                },
                            },
                            {
                                field: 'dataOriginacao',
                                headerName: 'DataOriginacao',
                                description: 'Preencha a data de originação de cada operação',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    // const index = id ? id - 1 : 0
                                    const index = operationsState.findIndex((op) => op.id === id)  
                                    console.log("Valor do index dataOriginacao:", index)
                                    console.log("dataOriginacao: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError dataOriginacao:", borderErrorOperacoes.dataOriginacao)      
                                                              
                                    const dataOriginacaoError = borderErrorOperacoesMemo[`op_${index}`]?.dataOriginacao ?? false
                                    console.log("Valor de dataOriginacaoError:", dataOriginacaoError)

                                    return (
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                format="DD/MM/YYYY"
                                                value={value ? dayjs(value, "DD/MM/YYYY") : null}
                                                onChange={(newValue) => {
                                                    const formattedDate = newValue ? dayjs(newValue).format('DD/MM/YYYY') : ""
                                                    handleOperationChange('dataOriginacao', id, formattedDate)
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        error: dataOriginacaoError,
                                                        helperText: dataOriginacaoError ? 'Data inválida' : '',
                                                        variant: "outlined",
                                                        fullWidth: true
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    )
                                },
                            },
                            {
                                field: 'dataVencimento',
                                headerName: 'DataVencimento',
                                description: 'Preencha a data de vencimento de cada operação',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id)  
                                    console.log("Valor do index dataVencimento:", index)
                                    console.log("dataVencimento: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError dataVencimento:", borderErrorOperacoes.dataVencimento)       
                                                              
                                    const dataVencimentoError = borderErrorOperacoesMemo[`op_${index}`]?.dataVencimento ?? false
                                    console.log("Valor de dataVencimentoError:", dataVencimentoError)

                                    return (
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                format="DD/MM/YYYY"
                                                value={value ? dayjs(value, "DD/MM/YYYY") : null}
                                                onChange={(newValue) => {
                                                    const formattedDate = newValue ? dayjs(newValue).format('DD/MM/YYYY') : ""
                                                    handleOperationChange('dataVencimento', id, formattedDate)
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        error: dataVencimentoError,
                                                        helperText: dataVencimentoError ? 'Data inválida' : '',
                                                        variant: "outlined",
                                                        fullWidth: true
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    )
                                },
                            },
                            {
                                field: 'CNPJ_CPF',
                                headerName: 'CNPJ_CPF',
                                description: 'Preencha o CNPJ ou CPF de cada operação',
                                align: "center", headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id)
                                    console.log("Valor do index CNPJ_CPF:", index)
                                    console.log("CNPJ_CPF: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError CNPJ_CPF:", borderErrorOperacoes.CNPJ_CPF)
                                    
                                    const CNPJ_CPFError = borderErrorOperacoesMemo[`op_${index}`]?.CNPJ_CPF ?? false
                                    console.log("Valor de CNPJ_CPFError:", CNPJ_CPFError)

                                    return (
                                        <EditableReceivableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationChange('CNPJ_CPF', id, cellValue)}
                                            error={CNPJ_CPFError} 
                                        />
                                    )
                                },
                            },
                            {
                                field: 'indexador',
                                headerName: 'Indexador',
                                description: 'Escolha entre as opções disponíveis o indexador para cada operação',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id)
                                    console.log("Valor do index indexador:", index)
                                    console.log("indexador: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError indexador:", borderErrorOperacoes.indexador)

                                    const indexadorError = borderErrorOperacoesMemo[`op_${index}`]?.indexador ?? false
                                    console.log("Valor de indexadorError:", indexadorError)
                                    
                                    return (
                                        <Select
                                            value={value}
                                            onChange={(event) => handleOperationChange('indexador', id, event.target.value)}
                                            fullWidth
                                            size="small"
                                            sx={{
                                                backgroundColor: indexadorError ? "red" : "transparent"
                                            }}
                                        >
                                            {indexadorOptions.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )
                                }
                            },
                            {
                                field: 'volumeFinanceiro',
                                headerName: 'VolumeFinanceiro',
                                description: 'Informe o volume financeiro para cada operação.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id)
                                    console.log("Valor do index volumeFinanceiro:", index)
                                    console.log("VolumeFinanceiro: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError volumeFinanceiro:", borderErrorOperacoes.volumeFinanceiro)

                                    const volumeFinanceiroError = borderErrorOperacoesMemo[`op_${index}`]?.volumeFinanceiro ?? false
                                    console.log("Valor de volumeFinanceiroError:", volumeFinanceiroError)

                                    return (
                                        <EditableNumberReceivableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationNumericChange('volumeFinanceiro', id, cleanFormattedNumber(cellValue))}
                                            error={volumeFinanceiroError}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'taxaOperacao',
                                headerName: 'TaxaOperacao',
                                description: 'Informe a taxa da operação para cada operação.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id)
                                    console.log("Valor do index taxaOperacao:", index)
                                    console.log("TaxaOperacao: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError taxaOperacao:", borderErrorOperacoes.taxaOperacao)

                                    const taxaOperacaoError = borderErrorOperacoesMemo[`op_${index}`]?.taxaOperacao ?? false
                                    console.log("Valor de taxaOperacaoError:", taxaOperacaoError)

                                    return (
                                        <EditableNumberReceivableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationNumericChange('taxaOperacao', id, cleanFormattedNumber(cellValue))}
                                            error={taxaOperacaoError}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'prazoOperacao',
                                headerName: 'PrazoOperacao',
                                description: 'Informe o prazo da operação para cada operação.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {        
                                    const index = operationsState.findIndex((op) => op.id === id)     
                                    console.log("Valor do index prazoOperacao:", index)
                                    console.log("prazoOperacao: ", value, "| Tipo: ", typeof value)
                                    console.log("Valor de borderError prazoOperacao:", borderErrorOperacoes.prazoOperacao)

                                    const prazoOperacaoError = borderErrorOperacoesMemo[`op_${index}`]?.prazoOperacao ?? false
                                    console.log("Valor de prazoOperacaoError:", prazoOperacaoError)

                                    return (
                                        <EditableNumberReceivableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationNumericChange('prazoOperacao', id, cleanFormattedNumber(cellValue))}
                                            error={prazoOperacaoError}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'diasAtraso',
                                headerName: 'DiasAtraso',
                                description: 'Informe os dias de atraso de cada operação.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {        
                                    const index = operationsState.findIndex((op) => op.id === id)     
                                    console.log("Valor do index diasAtraso:", index)
                                    console.log("diasAtraso: ", value, "| Tipo: ", typeof value)

                                    const diasAtrasoError = borderErrorOperacoesMemo[`op_${index}`]?.diasAtraso ?? false
                                    console.log("Valor de diasAtrasoError:", diasAtrasoError)

                                    return (
                                        <EditableNumberReceivableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationNumericChange('diasAtraso', id, cleanFormattedNumber(cellValue))}
                                            error={diasAtrasoError}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'PDDObservada',
                                headerName: 'PDDObservada',
                                description: 'Informe a PDD observada para cada operação.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id)     
                                    console.log("Valor do index PDDObservada:", index)
                                    console.log("PDDObservada: ", value, "| Tipo: ", typeof value)
                                    return (
                                        <EditableNumberReceivableInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationNumericChange('PDDObservada', id, cleanFormattedNumber(cellValue))}
                                            // error={PDDObservadaError}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'valorGarantia',
                                headerName: 'ValorGarantia',
                                description: 'Informar o valor da garantia de cada operação, quando aplicável.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index PDDObservada:", index)
                                    console.log("valorGarantia: ", value, "| Tipo: ", typeof value)
                                    return (
                                        <EditableNumberInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationNumericChange('valorGarantia', id, cleanFormattedNumber(cellValue))}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'recebivel',
                                headerName: 'Recebivel',
                                description: 'Escolha entre as opções disponíveis o recebivel para cada operação',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id)  
                                    console.log("Valor do index recebivel:", index)
                                    console.log("recebivel: ", value, "| Tipo: ", typeof value)

                                    const recebivelError = borderErrorOperacoesMemo[`op_${index}`]?.recebivel ?? false
                                    console.log("Valor de recebivelError:", recebivelError)
                                    
                                    return (
                                        <Select
                                            value={value}
                                            onChange={(event) => handleOperationChange('recebivel', id, event.target.value)}
                                            fullWidth
                                            size="small"
                                            sx={{
                                                backgroundColor: recebivelError ? "red" : "transparent"
                                            }}
                                        >
                                            {recebivelOptions.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )
                                }
                            },
                            {
                                field: 'garantia',
                                headerName: 'Garantia',
                                description: 'Escolha entre as opções disponíveis a garantia para cada operação',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index garantia:", index)
                                    console.log("garantia: ", value, "| Tipo: ", typeof value)

                                    const garantiaError = borderErrorOperacoesMemo[`op_${index}`]?.garantia ?? false
                                    console.log("Valor de garantiaError:", garantiaError)
                                    
                                    return (
                                        <Select
                                            value={value}
                                            onChange={(event) => handleOperationChange("garantia", id, event.target.value)}
                                            fullWidth
                                            size="small"
                                            sx={{
                                                backgroundColor: garantiaError ? "red" : "transparent"
                                            }}
                                        >
                                            {garantiaOptions.map((option) => (
                                                <MenuItem key={option} value={option}>
                                                    {option}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    )
                                }
                            },
                            {
                                field: 'PDInterno',
                                headerName: 'PDInterno',
                                description: 'Informar o PDInterno de cada operação, quando aplicável.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index PDInterno:", index)
                                    console.log("PDInterno: ", value, "| Tipo: ", typeof value)
                                    return(
                                        <EditableNumberInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationNumericChange('PDInterno', id, cleanFormattedNumber(cellValue))}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'LGDInterno',
                                headerName: 'LGDInterno',
                                description: 'Informar o LGDInterno de cada operação, quando aplicável.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index LGDInterno:", index)
                                    console.log("LGDInterno: ", value, "| Tipo: ", typeof value)
                                    return(
                                        <EditableNumberInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationNumericChange('LGDInterno', id, cleanFormattedNumber(cellValue))}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'EADInterno',
                                headerName: 'EADInterno',
                                description: 'Informar o EADInterno de cada operação, quando aplicável.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index EADInterno:", index)
                                    console.log("EADInterno: ", value, "| Tipo: ", typeof value)
                                    return(
                                        <EditableNumberInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationNumericChange('EADInterno', id, cleanFormattedNumber(cellValue))}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'ScoreInterno',
                                headerName: 'ScoreInterno',
                                description: 'Informar o ScoreInterno de cada operação, quando aplicável.',
                                align: "center", 
                                headerAlign: "center",
                                disableColumnMenu: true,
                                sortable: false,
                                width: 150,
                                renderCell: ({ id, value }) => {
                                    const index = operationsState.findIndex((op) => op.id === id) 
                                    console.log("Valor do index ScoreInterno:", index)
                                    console.log("ScoreInterno: ", value, "| Tipo: ", typeof value)
                                    return(
                                        <EditableNumberInput
                                            editable={true}
                                            fieldValue={value}
                                            handleChange={(cellValue) => handleOperationNumericChange('ScoreInterno', id, cleanFormattedNumber(cellValue))}
                                        />
                                    )
                                }
                            },
                            {
                                field: 'actions',
                                headerName: 'Excluir',
                                align: "center", headerAlign: "center",
                                width: 120,
                                renderCell: (params) => (
                                    <Button onClick={() => handleRemoveOperation(params.row.id)} color="error" align="center">
                                        <DeleteOutlineOutlinedIcon />
                                    </Button>
                                ),
                            }
                        ]}
                        disableRowSelectionOnClick
                    />
                </Grid>
                <br />
                <Grid container justifyContent={"space-between"}>
                    {/* operações */}
                    <Grid item>
                        <Grid container spacing={1} justifyContent={"flex-start"}>
                            <Grid item>
                                <Tooltip title="Adicione as operações da sua carteira, até no máximo 15 linhas">
                                    <Button onClick={handleAddOperation} variant="contained">
                                        + Operação
                                    </Button>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <br />
                <Grid container direction={'row'} justifyContent={"flex-start"} spacing={2}>
                    <Grid item xs={6} md={6} sm={6}>
                        <Tooltip title="Informe nome da carteira com até 100 caracteres">
                            <TextField
                                fullWidth
                                variant="standard"
                                type={"text"}
                                label="Nome da Carteira"
                                error={errorNomeCarteira}
                                helperText={errorNomeCarteira ? "Nome da carteira não pode estar vazio ou conter caracteres especiais" : ""}
                                value={nomeCarteira}
                                onChange={(event) => {
                                    const value = event.target.value
                                    if (!onlyTextRegex(value)) {
                                        setErrorNomeCarteira(true)
                                    } else {
                                        setErrorNomeCarteira(false)
                                    }
                                    setNomeCarteira(value)
                                }}
                            />
                        </Tooltip>
                    </Grid>
                    <Grid item xs={1} md={1} sm={1}>
                        <Tooltip title='Escolha um percentil de 1 a 99,99 para cálculo do CreditVar. Caso deixe em branco será considerado percentil 99.'>
                            <TextField
                                fullWidth
                                variant="standard"
                                type={"number"}
                                label="Percentil"
                                value={valorPercentil}
                                onChange={(event) => { setValorPercentil(event.target.value) }}
                            />
                        </Tooltip>
                    </Grid>
                    <Grid item xs={2} md={2} sm={2}>
                        <Tooltip title='Informar caixa da carteira, caso tenha.'>
                            <TextFieldFormatCurrency label={"Caixa"} value={valorCaixa} onChange={setValorCaixa} focused={true} />
                        </Tooltip>
                    </Grid>
                </Grid>
                <br />
                <Grid container direction={'column'} rowSpacing={2}>
                    {/* subordinações */}
                    <Grid item width={'100%'}>
                        <DataGrid
                            key={tableKey}
                            autoHeight={false}
                            autoPageSize={false}
                            showColumnVerticalBorder
                            showCellVerticalBorder
                            hideFooter
                            rows={subordinationsState}
                            columns={[
                                {
                                    field: 'id',
                                    headerName: '#',
                                    align: "center",
                                    disableColumnMenu: true,
                                    sortable: false,
                                    headerAlign: "center",
                                },
                                {
                                    field: 'nomeCota',
                                    headerName: 'Nome da Cota',
                                    description: 'Renomeie o nome das cotas caso queira',
                                    align: "center",
                                    headerAlign: "center",
                                    disableColumnMenu: true,
                                    sortable: false,
                                    flex: 1,
                                    renderCell: ({ id, value }) => <EditableInput
                                        editable={true}
                                        fieldValue={value}
                                        handleChange={(cellValue) => handleSubordinationChange('nomeCota', id, cellValue)}
                                    />,
                                },
                                {
                                    field: 'plCota',
                                    headerName: 'PL da Cota',
                                    description: 'Preencha o valor de patrimônio líquido de cada uma das cotas',
                                    align: "center", headerAlign: "center",
                                    disableColumnMenu: true,
                                    sortable: false,
                                    flex: 1,
                                    renderCell: ({ id, value }) => {
                                        const index = id -1
                                        console.log("Valor do index:", index)
                                        console.log("Valor de borderError plCota:", borderErrorSubordinacoes.plCota)
                                        
                                        const plCotaError = borderErrorSubordinacoesMemo[`sub_${index}`]?.plCota ?? false
                                        console.log("Valor de plCotaError:", plCotaError)

                                        return (
                                            <EditableNumberReceivableInput
                                                editable={true}
                                                fieldValue={value}
                                                handleChange={(cellValue) => handleSubordinationNumericChange('plCota', id, cleanFormattedNumber(cellValue))}
                                                error={plCotaError} 
                                            />
                                        )
                                    },
                                },
                                {
                                    field: 'indexador',
                                    headerName: 'Indexador',
                                    description: 'Informe a taxa de carrego quando for a cota júnior ou cota única, para as demais cotas superiores a taxa accrual',
                                    align: "center", 
                                    headerAlign: "center",
                                    disableColumnMenu: true,
                                    sortable: false,
                                    flex: 1,
                                    renderCell: ({ id, value }) => {
                                        const index = id -1
                                        console.log("Valor do index:", index)
                                        console.log("Valor de borderError indexador:", borderErrorSubordinacoes.indexador)

                                        const indexadorError = borderErrorSubordinacoesMemo[`sub_${index}`]?.indexador ?? false
                                        console.log("Valor de indexadorError:", indexadorError)
                                        
                                        return (
                                            <EditableReceivableInput
                                                editable={true}
                                                fieldValue={value}
                                                handleChange={(cellValue) => handleSubordinationChange('indexador', id, cellValue)}
                                                error={indexadorError}
                                            />
                                        )
                                    }
                                },
                                {
                                    field: 'taxaAccrual',
                                    headerName: 'TaxaAccrual',
                                    description: 'Informe a taxa de carrego do estoque quando for cota júnior ou cota única, para as demais cotas informar a taxa contratada.',
                                    align: "center", 
                                    headerAlign: "center",
                                    disableColumnMenu: true,
                                    sortable: false,
                                    flex: 1,
                                    renderCell: ({ id, value }) => {
                                        const index = id -1
                                        console.log("Valor do index:", index)
                                        // console.log("Valor de borderError taxaAccrual:", borderErrorSubordinacoes.taxaAccrual)
                                        
                                        const taxaAccrualError = borderErrorSubordinacoesMemo[`sub_${index}`]?.taxaAccrual ?? false
                                        console.log("Valor de taxaAccrualError:", taxaAccrualError)

                                        return (
                                            <EditableNumberReceivableInput
                                                editable={true}
                                                fieldValue={value}
                                                handleChange={(cellValue) => handleSubordinationNumericChange('taxaAccrual', id, cleanFormattedNumber(cellValue))}
                                                error={taxaAccrualError}
                                            />
                                        )
                                    }
                                },
                                {
                                    field: 'durationCota',
                                    headerName: 'DurationCota',
                                    description: 'Para as cotas superiores informe a duration ou prazo médio, em dias úteis, do vencimento da cota. Caso não modifique será considerado 252 du.',
                                    align: "center", 
                                    headerAlign: "center",
                                    disableColumnMenu: true,
                                    sortable: false,
                                    flex: 1,
                                    renderCell: ({ id, value }) => <EditableInput
                                        editable={true}
                                        fieldValue={value}
                                        handleChange={(cellValue) => handleSubordinationNumericChange('durationCota', id, cleanFormattedNumber(cellValue))}
                                    />,
                                },
                                {
                                    field: 'actions',
                                    headerName: 'Excluir',
                                    align: "center", headerAlign: "center",
                                    width: 120,
                                    renderCell: (params) => (
                                        <Button onClick={() => handleRemoveSubordination(params.row.id)} color="error" align="center">
                                            <DeleteOutlineOutlinedIcon />
                                        </Button>
                                    ),
                                }
                            ]}
                            disableRowSelectionOnClick
                        />
                    </Grid>
                    <br />
                    {/* botão + subordinação */}
                    <Grid container justifyContent={"space-between"}>
                        <Grid item>
                            <Grid container spacing={1} justifyContent={"flex-start"}>
                                <Grid item>
                                    <Button onClick={handleAddSubordination} variant="contained">
                                        <Tooltip title="Adicione as cotas de subordinação da sua carteira, quantas forem necessárias">
                                            + Subordinação
                                        </Tooltip>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br />
                    {/* botões cancelar e calcular */}
                    <Grid item>  
                        <Grid container spacing={1} justifyContent={"flex-end"}>
                            <Grid item>
                                <Button variant="outlined" onClick={closeModal}>
                                    Cancelar
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button variant="contained" onClick={() => {
                                    handleUploadForm()
                                }}>Calcular</Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br />
                </Grid>
            </Grid>
        </form>
    )
}

export default FormWalletComponent

FormWalletComponent.propTypes = {
    tableKey: PropTypes.array.isRequired,
    nomeCarteira: PropTypes.string.isRequired,
    setNomeCarteira: PropTypes.func.isRequired,
    errorNomeCarteira: PropTypes.bool.isRequired,
    setErrorNomeCarteira: PropTypes.func.isRequired,
    valorPercentil: PropTypes.number.isRequired,
    setValorPercentil: PropTypes.func.isRequired,
    valorCaixa: PropTypes.number.isRequired,
    setValorCaixa: PropTypes.number.isRequired,
    operationsState: PropTypes.array.isRequired,
    setOperationsState: PropTypes.func.isRequired,
    subordinationsState: PropTypes.array.isRequired,
    setSubordinationsState: PropTypes.func.isRequired,
    borderErrorSubordinacoes:PropTypes.object.isRequired,
    borderErrorOperacoes: PropTypes.object.isRequired,
    handleOperationNumericChange: PropTypes.func.isRequired,
    handleOperationChange: PropTypes.func.isRequired,
    handleSubordinationNumericChange: PropTypes.func.isRequired,
    handleSubordinationChange: PropTypes.func.isRequired,
    handleRemoveSubordination: PropTypes.func.isRequired,
    handleUploadForm: PropTypes.func.isRequired,
    handleAddSubordination: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    openAlert: PropTypes.func.isRequired
}